import { api_referral } from './utils';

export const validateReferralCode = async (code: string, address: string) => {
	const response = await api_referral('post', `referrals/validate`, {
		referralCode: code,
		referee: address
	});

	if (response.status === 201) {
		const data = await response.json();
		return data;
	}
	return null;
};

export const acceptReferral = async (address: string, code: string, signature: string) => {
	const response = await api_referral('post', `referrals`, {
		referee: address,
		referralCodeUsed: code,
		signature
	});

	const data: any = await response.json();

	if (response.status === 201) {
		return data;
	}

	throw new Error((data.message as string) || 'Error accepting referral');
};
